import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/instagramFeedApi"; 
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonTemplateWidget from "../../../../components/Apps/InstagramFeed/Template/CommonTemplateWidget";

//Import Tabs
import SourcesTab from "../../../../components/Apps/InstagramFeed/SourcesTab";
import LayoutTab from "../../../../components/Apps/InstagramFeed/LayoutTab";
import PostTab from "../../../../components/Apps/InstagramFeed/PostTab";
import StyleTab from "../../../../components/Apps/InstagramFeed/StyleTab";
import SettingsTab from "../../../../components/Apps/InstagramFeed/SettingsTab";

export default function CreateInstagramFeed() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Sources");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Profile_Widget_Temp");
    const [selectedLayout, setSelectedLayout] = useState("slider_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("profile-widget.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Instagram Feed");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [instagramFeedTabData, setInstagramFeedTabData] = useState({
        is_website_frontend: "", 
        source_type: "account",  
        source_search_name: "",
        columns_mode_type: "auto",  
        layout_columns: 4,  
        layout_rows: 2,  
        layout_item_spacing: 5, 
        layout_is_full_width: 0,     
        layout_custom_width: "1280",    
        header_is_show_header: 1, 
        header_profile_picture: 1, 
        header_full_name: 1, 
        header_username: 1, 
        header_verified_badge: 1, 
        header_posts_count: 1, 
        header_followers_count: 1, 
        header_following_count: 1, 
        header_follow_button: 1, 
        feed_title: "", 
        language_type: "English", 
        post_likes_count: 1,
        post_comments_count: 1,
        post_text: 1,
        popup_user: 1,
        popup_instagram_link: 1,
        popup_likes_count: 1,
        popup_share: 1,
        popup_text: 1,
        popup_comments: 1,
        popup_date: 1,
        post_click_action: "None",
        header_background_color: "",
        header_text_color: "",
        header_follow_button_color: "",
        header_follow_button_text_color: "",
        header_post_overlay_background: "",
        header_post_overlay_text: "",
        load_more_button: "",
        popup_color_overlay: "",
        popup_background_color: "",
        popup_text_color: "",
        popup_links_color: "",
        popup_follow_button_color: "",
        popup_action_button_color: "",
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let layout_columns = "";
            let layout_rows = "";
            let layout_is_full_width = "";
            let layout_custom_width = "";
            let header_background_color = "";
            let header_text_color = "";
            let header_follow_button_color = "";
            let header_follow_button_text_color = "";
            let header_post_overlay_background = "";
            let header_post_overlay_text = "";
            let load_more_button = "";
            let popup_color_overlay = "";
            let popup_background_color = "";
            let popup_text_color = "";
            let popup_links_color = "";
            let popup_follow_button_color = "";
            let popup_action_button_color = "";
        
            switch (activeTemplateSection) {
                case "Profile_Widget_Temp":
                    layout_columns = 4;
                    layout_rows = 2;
                    layout_is_full_width = 1;
                    layout_custom_width = 1280;
                    header_background_color = "#f8f8f8";
                    header_text_color = "rgb(33, 37, 41)";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(0, 0, 0, 0.8)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
                    break;
                case "Grid_Temp":
                    layout_columns = 4;
                    layout_rows = 2;
                    layout_is_full_width = 1;
                    layout_custom_width = 1280;
                    header_background_color = "#f8f8f8";
                    header_text_color = "rgb(33, 37, 41)";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(0, 0, 0, 0.8)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
                    break;
                case "Small_Widget_Temp":
                    layout_columns = 2;
                    layout_rows = 1;
                    layout_is_full_width = 0;
                    layout_custom_width = 750;
                    header_background_color = "#f8f8f8";
                    header_text_color = "rgb(33, 37, 41)";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(0, 0, 0, 0.8)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
                    break;
                case "Hashtag_Showcase_Temp":
                   layout_columns = 4;
                    layout_rows = 2;
                    layout_is_full_width = 1;
                    layout_custom_width = 1280;
                    header_background_color = "#f8f8f8";
                    header_text_color = "rgb(33, 37, 41)";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(0, 0, 0, 0.8)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
                    break;
                case "Post_Slider_Temp":
                    layout_columns = 4;
                    layout_rows = 2;
                    layout_is_full_width = 1;
                    layout_custom_width = 1280;
                    header_background_color = "#f8f8f8";
                    header_text_color = "rgb(33, 37, 41)";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(0, 0, 0, 0.8)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
                    break;
                case "Dark_Profile_Widget_Temp":
                    layout_columns = 4;
                    layout_rows = 2;
                    layout_is_full_width = 1;
                    layout_custom_width = 1280;
                    header_background_color = "#000";
                    header_text_color = "#fff";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(160, 79, 7, 0.9)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
                    break;
                default:
                    layout_columns = 4;
                    layout_rows = 2;
                    layout_is_full_width = 0;
                    layout_custom_width = 1280;
                    header_background_color = "#000";
                    header_text_color = "#fff";
                    header_follow_button_color = "#1b90e5";
                    header_follow_button_text_color = "#fff";
                    header_post_overlay_background = "rgba(160, 79, 7, 0.9)";
                    header_post_overlay_text = "#fff";
                    load_more_button = "#000";
                    popup_color_overlay = "#000";
                    popup_background_color = "#000";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    popup_follow_button_color = "#000";
                    popup_action_button_color = "#000";
            }
        
            // Update setInstagramFeedTabData state with the data
            setInstagramFeedTabData((prevData) => ({
                ...prevData,
                layout_columns: layout_columns,
                layout_rows: layout_rows,
                layout_is_full_width: layout_is_full_width,
                layout_custom_width: layout_custom_width,
                header_background_color: header_background_color,
                header_text_color: header_text_color,
                header_follow_button_color: header_follow_button_color,
                header_follow_button_text_color: header_follow_button_text_color,
                header_post_overlay_background: header_post_overlay_background,
                header_post_overlay_text: header_post_overlay_text,
                load_more_button: load_more_button, 
                popup_color_overlay: popup_color_overlay, 
                popup_background_color: popup_background_color, 
                popup_text_color: popup_text_color, 
                popup_links_color: popup_links_color, 
                popup_follow_button_color: popup_follow_button_color, 
                popup_action_button_color: popup_action_button_color, 
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateInstagramFeedTabData = (key, value) => {
        setInstagramFeedTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Sources", icon: "sources.png", label: "Sources" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Post", icon: "post.png", label: "Post" },
      { key: "Style", icon: "style.png", label: "Style" },
      { key: "Settings", icon: "settings.png", label: "Settings" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true); 
      try {
        // Collect data from refs
        const settingsArray = Object.entries(instagramFeedTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                source_type: instagramFeedTabData.source_type,
                username_or_url: instagramFeedTabData.source_search_name,
                settings: settingsArray,
          };
          
          //Api Call
         let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/instagram-feed');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
    };

    // Handle Layout Change
    const handleLayoutChange = (e) => {
        setSelectedLayout(e.target.value);
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Instagram Feed" app_type="Instagram_Feed" app_slug="instagram-feed"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Profile_Widget_Temp" data-layout_type="slider_layout" data-template_image="profile-widget.png" checked={activeTemplateSection === "Profile_Widget_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/instagram-feed/templates/profile-widget.png`} alt="profile-widget" />
                                    </div> 
                                    <div className="content_sub">Profile Widget</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Grid_Temp" data-layout_type="grid_layout" data-template_image="grid.png" checked={activeTemplateSection === "Grid_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/instagram-feed/templates/grid.png`} alt="grid" />
                                    </div> 
                                    <div className="content_sub">Grid</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Small_Widget_Temp" data-layout_type="slider_layout" data-template_image="small-widget.png" checked={activeTemplateSection === "Small_Widget_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/instagram-feed/templates/small-widget.png`} alt="small-widget" />
                                    </div> 
                                    <div className="content_sub">Small Widget</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Hashtag_Showcase_Temp" data-layout_type="grid_layout" data-template_image="hashtag-showcase.png" checked={activeTemplateSection === "Hashtag_Showcase_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/instagram-feed/templates/hashtag-showcase.png`} alt="hashtag-showcase" />
                                    </div> 
                                    <div className="content_sub">Hashtag Showcase</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Post_Slider_Temp" data-layout_type="slider_layout" data-template_image="post-slider.png" checked={activeTemplateSection === "Post_Slider_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/instagram-feed/templates/post-slider.png`} alt="post-slider" />
                                    </div> 
                                    <div className="content_sub">Post Slider</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dark_Profile_Widget_Temp" data-layout_type="grid_layout" data-template_image="dark-profile-widget.png" checked={activeTemplateSection === "Dark_Profile_Widget_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/instagram-feed/templates/dark-profile-widget.png`} alt="dark-profile-widget" />
                                    </div> 
                                    <div className="content_sub">Dark Profile Widget</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/instagram-feed/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Sources" && (
                              <SourcesTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab handleLayoutChange={handleLayoutChange} selectedLayout={selectedLayout} updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                            )}
                            {activeSection === "Post" && (
                              <PostTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingsTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/instagram-feed"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/instagram-feed/instagram-feed.svg`} alt="instagram-feed"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/instagram-feed/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/instagram-feed" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">Instagram Feed <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common Template Widgets*/}
                    <CommonTemplateWidget selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} instagramFeedTabData={instagramFeedTabData} />
                </div> 
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 